export default "__VITE_ASSET__C$Sf92bj__"